module.exports = __webpack_public_path__ + "img/accept-terms-bg.9df52bc7.jpg";